<template>
    <div v-if="!rowPinned" class="show-errors-cell-renderer d-flex align-items-center">
        <responsive-button variant="outline-primary" title="Show" :responsiveness="false" size="sm" @click="showErrors">
            Show
        </responsive-button>
        <modal :id="showErrorsModalId" title="Errors" ok-only>
            <p>{{ errors }}</p>
        </modal>
    </div>
</template>
<script>
import Modal from '../../generic/modal/modal.vue';
import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';

export default {
    components: { Modal, ResponsiveButton },
    data() {
        return {
            showErrorsModalId: null,
            errors: [],
        };
    },
    created() {
        this.showErrorsModalId = `show-errors-modal-id-${this.params.data.id}`;
        this.errors = this.params.data.errors;
        this.rowPinned = this.params.node.rowPinned;
    },
    methods: {
        showErrors() {
            this.$bvModal.show(this.showErrorsModalId);
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.btn:focus) {
    box-shadow: none !important;
}
</style>
